var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBungaloIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2058 1524",
    style: {
      enableBackground: "new 0 0 2058 1524"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#EDA145;}\r\n\t.st2{fill:#EF9F53;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1484.1,719.8v12.4h-24v62.6h-14.9v-62.6h-24v-12.4H1484.1z M1566.1,794.8l-2.8-44.1c-0.3-5.8-0.3-13-0.6-20.9 h-0.8c-1.9,6.6-4.1,15.4-6.3,22.3l-13.5,41.6h-15.4l-13.5-42.7c-1.4-5.8-3.6-14.6-5.2-21.2h-0.8c0,6.9-0.3,14.1-0.6,20.9l-2.8,44.1 h-14.3l5.5-75h22.3l13,36.7c1.7,5.8,3,11.3,5,19h0.3c1.9-6.9,3.6-13.2,5.2-18.7l13-36.9h21.5l5.8,75H1566.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1088.5,893.5c117.3,0,196.2,89.7,196.2,223.1c0,134.4-78.8,224.7-196.2,224.7 c-116.5,0-197.8-92.4-197.8-224.7C890.7,962.5,990,893.5,1088.5,893.5 M896.1,1411.4c43.7,70.6,129.2,112.7,228.8,112.7 c214.7,0,364.6-168.2,364.6-409c0-116-32.4-215.7-93.6-288.4c-63.8-75.7-154.8-115.8-263.1-115.8c-123.8,0-203.2,56.4-233.6,104.8 l-5.4,8.6V463.1H692.2V1505H858l34.9-98.8L896.1,1411.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2058.1,683.5C1999.8,555.2,1707.9-0.1,1026.9-0.1C346.4-0.1,57.9,554.1-0.1,683.5h211.8 c92.8-165.5,337.1-493.7,815.1-493.7c482.6,0,726.8,327.6,819.6,493.7H2058.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1435.9,733.1c0-35.7,28.4-64.4,64.4-64.4c36.5,0,64.4,28.4,64.4,64.1c0,36.3-28.4,64.1-64.4,64.1 C1464.6,796.9,1435.9,769.4,1435.9,733.1z M1553.1,732.8c0-31.6-22-53.7-52.8-53.7s-52.8,22.3-52.8,54c0,31.9,23.2,53.4,52.8,53.4 C1530.1,786.5,1553.1,764.4,1553.1,732.8z M1478.2,700.3h22.3c14.8,0,24.4,6.1,24.4,19.1v0.3c0,9.6-5.5,14.8-13.1,17.1l16.8,27 h-14.5l-15.4-24.7h-6.7v24.7h-13.9V700.3z M1500.3,729.6c7.3,0,11-3.2,11-9.3v-0.3c0-6.7-4.1-9-11-9h-8.1v18.6H1500.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBungaloIcon);
export default __webpack_public_path__ + "static/media/bungaloIcon.166527d917a4a20d7bd9130a83cda495.svg";
export { ForwardRef as ReactComponent };